import React from 'react';
import { ThemeProvider } from '@material-ui/core/styles';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { RecoilRoot, useRecoilValue } from 'recoil';
import CookieConsent from 'react-cookie-consent';

import { DisplayError } from './common/components';
import { MainWrapper } from './common/containers';
import { themeState } from './state';

import { unstable_createMuiStrictModeTheme as createMuiTheme } from '@material-ui/core/styles';

function ThemeProviderWrapper({ children }) {
	const theme = useRecoilValue(themeState);

	return (
		<ThemeProvider theme={createMuiTheme(theme)}>{children}</ThemeProvider>
	);
}

function App() {
	return (
		<>
			<CookieConsent
				location="bottom"
				sameSite="strict"
				buttonText="Nadaljuj"
				style={{ zIndex: 1501 }}
				expires={365}>
				Spletna stran uporablja piškotke, s katerimi zagotavljamo naprednejšo
				uporabniško izkušnjo. Z uporabo te spletne strani se strinjate, da na
				računalnik namestimo piškotke za ta namen.
			</CookieConsent>
			<RecoilRoot>
				<Router basename={process.env.PUBLIC_URL}>
					<ThemeProviderWrapper>
						<Switch>
							<Route path="/:url">
								<MainWrapper />
							</Route>
							<Route path="*">
								<DisplayError error={'Forma ne obstaja'} />
							</Route>
						</Switch>
					</ThemeProviderWrapper>
				</Router>
			</RecoilRoot>
		</>
	);
}

export default App;
